import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LockHistoryItem } from "@/services/entities/LockHistoryItem";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";
import LockDetail from "@/components/lock/LockDetail.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LockModal',
  props: {
  locks: { Type: [] as LockHistoryItem[], default: [] as LockHistoryItem[] },
  userName: { Type: {} as string, default: "Unknown" as string },
  userId: { Type: {} as string, default: "" as string },
  year: { Type: {} as number },
  month: { Type: {} as number },
},
  emits: ["close", "refreshUsers"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const emit = __emit;

const props = __props;

// const state = reactive({
//   value: {
//     dateFrom: new Date(),
//     dateTo: new Date(),
//     isLocked: false,
//     isPlaceholder: false,
//     lockedUserId: "",
//   },
// });

function beforeClose() {
  vfm.open(confirmModalId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(LockDetail, {
        locks: props.locks,
        userName: props.userName,
        userId: props.userId,
        year: props.year,
        month: props.month,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
        onRefreshUsers: _cache[1] || (_cache[1] = ($event: any) => (emit('refreshUsers')))
      }, null, 8, ["locks", "userName", "userId", "year", "month"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[2] || (_cache[2] = 
        () => {
          _unref(vfm).close(_unref(confirmModalId));
          emit('close');
        }
      ),
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})